import * as React from 'react';

import './Button.scss';

export default class Button extends React.Component<IButtonProps, any> {
  constructor(props: IButtonProps) {
    super(props);
  }
  public handleKeyDown= (event:any) => {   	
    if(event.keyCode === 13) {    
      if (!this.props.disabled) {    
        this.props.action();    
      }  
  }    
}
  private buildButton = () => {
    let classNames = this.props.buttonClass;
    const styles = {
      height: 'auto',
      width: 'auto'
    };
    let iconTag: any = <i />;

    classNames = this.props.icon
      ? `${classNames} ${this.props.icon.position}`
      : `${classNames} no-icon`;
    classNames = this.props.textTransform
      ? (classNames = `${classNames} ${this.props.textTransform}`)
      : classNames;

    classNames =
      this.props.disabled === true
        ? (classNames = `${classNames} disabled`)
        : classNames;
    styles.height = this.props.height
      ? (styles.height = `${this.props.height}`)
      : styles.height;
    styles.width = this.props.width
      ? (styles.width = `${this.props.width}`)
      : styles.width;
    iconTag =
      this.props.icon && this.props.icon.icon ? (
        <i className={this.props.icon.icon} />
      ) : (
        <React.Fragment />
      );

    return (
      <div role="button"  tabIndex={0}
        className={`rp-button ${classNames} no-select`}
        style={styles}
        onClick={() => {
          if (!this.props.disabled) {
            this.props.action();
          }
        }}
        
        onKeyDown={this.handleKeyDown}
      >
        <p>{this.props.label}</p>
        {iconTag}
        {this.props.children}
      </div>
    );
  };

  public render() {
    return this.buildButton();
  }
}

export interface IButtonProps {
  label?: string;
  buttonClass?: string;
  textTransform?: 'capitalize' | 'uppercase' | 'lowercase';
  height?: string;
  width?: string;
  icon?: {
    position?: string;
    icon?: string;
  };
  action?: any;
  disabled?: boolean;
}
